// Third party packages
import { BehaviorSubject } from "rxjs";
import * as i0 from "@angular/core";
var ListsService = /** @class */ (function () {
    function ListsService() {
        this.listsSettings$ = new BehaviorSubject([]);
        this.listSettings = [];
        this.disabled = false;
    }
    /**
     * Class constructor
     */
    // constructor() {}
    /**
     * Create a new listSetting with given value and check if
     * created listSetting is a new one or an update of an exising
     * one and than perform the add/update operation. Then
     * emit new value for listSettings$ BehaviorSubject()
     *
     * @since 1.0.0
     *
     * @param name Name of the settings. Usually the plural of the referral module
     * @param pageIndex Current page index
     * @param pageSize Current page size
     */
    ListsService.prototype.setListSetting = function (name, pageIndex, pageSize, search) {
        if (this.disabled) {
            return;
        }
        var newSetting = {
            name: name,
            pageIndex: pageIndex,
            pageSize: pageSize,
            search: search
        };
        var listSettingExists = this.listSettings.find(function (setting) { return setting.name === name; });
        if (listSettingExists) {
            this.updateListSetting(newSetting);
        }
        else {
            this.addNewSetting(newSetting);
        }
    };
    /**
     * Updates an existing setting with new values
     * and emit a new value to the BehaviorSubject()
     *
     * @since 1.0.0
     */
    ListsService.prototype.updateListSetting = function (newSetting) {
        this.listSettings.map(function (setting) {
            if (setting.name === newSetting.name) {
                Object.assign(setting, newSetting);
            }
        });
        this.listsSettings$.next(this.listSettings);
    };
    /**
     * Add a new setting to the settings' list
     * and emit a new value to the BehaviorSubject()
     *
     * @since 1.0.0
     */
    ListsService.prototype.addNewSetting = function (newSetting) {
        this.listSettings.push(newSetting);
        this.listsSettings$.next(this.listSettings);
    };
    /**
     * Reset all settings
     *
     * @since 1.0.0
     */
    ListsService.prototype.resetAllSettings = function () {
        this.listSettings.map(function (setting) {
            setting.pageIndex = 0;
            setting.pageSize = 10;
            Object.keys(setting.search).forEach(function (settingKey) {
                setting.search[settingKey] = "";
            });
            return setting;
        });
        this.listsSettings$.next(this.listSettings);
        this.disable();
    };
    /**
     * Enable list setting
     *
     * @since 1.0.0
     */
    ListsService.prototype.enable = function () {
        this.disabled = false;
    };
    /**
     * Disable list setting
     *
     * @since 1.0.0
     */
    ListsService.prototype.disable = function () {
        this.disabled = true;
    };
    ListsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ListsService_Factory() { return new ListsService(); }, token: ListsService, providedIn: "root" });
    return ListsService;
}());
export { ListsService };
